import React from 'react';
import PropTypes from "prop-types"
import Icon from '@mdi/react';
import { mdiEmail, mdiLinkedin } from '@mdi/js';

const SocialLinks = props => {
  const { customClass, showFullEmail } = props
  return (
    <div className={customClass}>
      <a href="mailto:hello@planetargon.com" className="is-header-link" >
        {showFullEmail && <span className="email-text has-text-white">hello@planetargon.com</span>}
        <Icon path={mdiEmail} size={1} color="" className="email-icon" title="Contact Planet Argon via Email" />
      </a>

      <a href="https://www.linkedin.com/company/planet-argon/" target="_blank" rel="noreferrer"  className="is-header-link">
        <Icon path={mdiLinkedin} size={1} color="" className="linkedin-icon" title="Connect with Planet Argon on LinkedIn" />
      </a>

      <a href="https://x.com/planetargon" target="_blank" rel="noreferrer"  className="is-header-link">
        <svg viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" style={{ width: "1.5rem", height: "1.5rem" }} aria-labelledby="icon_x_label">
          <g fill="#fff" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
            <title id="icon_x_label">Follow Planet Argon on X</title>
            <path d="m10.4 10 5.3 6.9h.8l-5.2-6.9z"/><path d="m13.5 2.2c-6.2 0-11.3 5.1-11.3 11.3s5 11.2 11.2 11.2 11.2-5 11.2-11.2-4.9-11.3-11.1-11.3zm1.8 15.6-2.3-3-2.6 3h-1.5l3.4-3.9-3.6-4.7h3l2.1 2.8 2.4-2.8h1.5l-3.2 3.7 3.8 5h-3z"/>
          </g>
          </svg>
      </a>
    </div>
  )
}

SocialLinks.propTypes = {
  customClass: PropTypes.string,
  showFullEmail: PropTypes.bool
}

SocialLinks.defaultProps = {
  customClass: "is-header-links",
  showFullEmail: true
}

export default SocialLinks